// extracted by mini-css-extract-plugin
export default {"spinner-container":"Spinner_spinner-container__MpZSM"};